module.exports = __webpack_public_path__ + "img/1949-Groveland USA.0461304c.jpg";